import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
const InternalEstateSearchFilterOnText = (props) => {
    const {
        labelMin,
        labelMax,
        attributeMin,
        attributeMax,
        filterValues,
    } = props;
    const component = useRef(null);
    const style = { marginRight: '1rem', width: '50%' };
    const divsStyle = { display: 'flex', width: '20%' };
    return (
        <React.Fragment>
            <div
                className="estate-search-filter estate-search-filter--inline"
                ref={component}
                style={divsStyle}
            >
                <input
                    value={filterValues.attributeMin}
                    type="number"
                    className="ais-SearchBox-input"
                    placeholder={labelMin}
                    style={style}
                    onChange={(event) =>
                        props.inputHandler(attributeMin, event.target.value)
                    }
                    // id={props}
                />
                <input
                    className="ais-SearchBox-input"
                    placeholder={labelMax}
                    value={filterValues.attributeMax}
                    type="number"
                    style={{ width: '50%' }}
                    onChange={(event) =>
                        props.inputHandler(attributeMax, event.target.value)
                    }
                    // id={props}
                />
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        filterValues: state.filterValues,
    };
};

const EstateSearchFilterOnText = connect(
    mapStateToProps,
    null,
)(InternalEstateSearchFilterOnText);

export { EstateSearchFilterOnText };
